import { call, put } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import { captureException } from '@sentry/core'
import platform from 'modules/platform'
import { loggedOut } from 'modules/auth/actions'
import { NOT_LOGGED_IN_ERROR_MESSAGE } from './errors'

/**
 * Wraps a saga handler so an error in it is reported rather than propagated. An uncaught error in a
 * handler doesn't stop at the handler: redux-saga cancels the watcher that forked it and every other
 * saga up the tree, leaving an app whose UI still works but which no longer uploads, syncs or
 * navigates. The root saga's onError is a notification on the way down, not a recovery.
 */
export function guarded<A>(handler: (action: A) => SagaIterator): (action: A) => SagaIterator {
	return function* (action: A): SagaIterator {
		try {
			yield call(handler, action)
		} catch (error) {
			if (error instanceof Error && error.message === NOT_LOGGED_IN_ERROR_MESSAGE) {
				yield put(loggedOut())
				return
			}

			console.error('SAGA: handler failed', error)
			captureException(error)
			platform.alert(`An internal error has occurred: ${error instanceof Error ? error.message : error}`)
		}
	}
}
